export default "__VITE_ASSET__C_m1g_Ad__"